import useLayout from '@/composables/useLayout';
import { watch } from '@vue/composition-api';
import { getDefaultGroup, pureGetMatchedGroupId, setGroupId } from '../../utils';
import { useBaseInfo } from './useBaseInfo';
export function useAutoUpdateGroupId() {
    const { visibleSidebarGroups } = useLayout();
    const { options } = useBaseInfo();
    watch(() => [options.value, visibleSidebarGroups.value], ([optionsData, groupsData]) => {
        setGroupId(pureGetMatchedGroupId(groupsData, optionsData) || getDefaultGroup()?.groupId);
    });
}
